/**
 * SIDEBAR STORE
 */

import Vue from "vue";
import api from "Api";
//import VueNotifications from 'vue-notifications';
import router from "Router";

import { employeeMenus, customerMenus, vendorMenus, continuousMenus, batchMenus, menu } from "Application/data/sidebar.data.js";

const state = {
    employeeMenus,
    customerMenus,
    vendorMenus,
    continuousMenus,
    batchMenus,
    menu,
    helpArticleMenu: false,
    drawer: JSON.parse(localStorage.getItem("drawer")),
    filteredMenu: {},
};

const getters = {
    customerMenu: (state) => {
        return state.customerMenus;
    },
    vendorMenu: (state) => {
        return state.vendorMenus;
    },
    employeeMenu: (state) => {
        return state.employeeMenus;
    },
    continuousMenu: (state) => {
        return state.continuousMenus;
    },
    batchMenu: (state) => {
        return state.batchMenus;
    },
    menu: (state) => {
        return state.menu;
    },
    helpArticleMenu: (state) => {
        return state.helpArticleMenu;
    },
    drawer: (state) => {
        return state.drawer;
    },
    filteredMenu: (state) => {
        return state.filteredMenu;
    },
};

const actions = {
    setActiveMenuGroup(context, payload) {
        context.commit("setActiveMenuGroupHandler", payload);
    },
    toggleHelpArticleMenu(context, payload) {
        context.commit("toggleHelpArticleMenuHandler", payload);
    },
};

const mutations = {
    setActiveMenuGroupHandler(state, router) {
        let fullPath = router.history.current.fullPath;
        let path = fullPath.split("/");
        let matchedPath = "/" + path[2] + "/" + path[3];
        //console.log(state.menu);
        for (const category in state.menus) {
            for (const menuGroup in state.menus[category]) {
                if (state.menus[category][menuGroup].items !== null) {
                    for (const matched in state.menus[category][menuGroup].items) {
                        if (
                            state.menus[category][menuGroup].items[matched].path == matchedPath ||
                            state.menus[category][menuGroup].items[matched].path == fullPath
                        ) {
                            state.menus[category][menuGroup].active = true;
                            console.log("IS ACTIVE", fullPath);
                        }
                    }
                }
            }
        }
    },
    setMenu(state, group) {
        state.menu = group;
    },
    toggleHelpArticleMenuHandler(state, payload) {
        payload === false ? (state.helpArticleMenu = payload) : (state.helpArticleMenu = !state.helpArticleMenu);
    },
    toggleMainMenu(state, payload) {
        payload === false ? (state.drawer = payload) : (state.drawer = !state.drawer);
        localStorage.setItem("drawer", state.drawer);
    },
    // setFilteredMenu(state, { user }) {
    // 	let menu_keys = Object.keys(state.menu);
    // 	if (user) {
    // 		menu_keys.forEach((key, index) => {
    // 			if (state.menu[key] && (state.menu[key] || []).length > 0) {
    // 				state.filteredMenu[key] = state.menu[key].filter((m) => {
    // 					return !m.permission || user.global.includes(`${m.permission}`);
    // 				});

    // 				// Iterate through filtered_menu[key] if the item has an items key and if it has a length greater than 0 then filter the items based on the module.read permission
    // 				state.filteredMenu[key].forEach((item, index) => {
    // 					if (item.items && item.items.length > 0) {
    // 						state.filteredMenu[key][index]["items"] = item["items"].filter((i) => {
    // 							return !i.permission || user.global.includes(`${i.permission}`);
    // 						});
    // 					}
    // 				});
    // 			}
    // 		});
    // 	}
    // }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
